import Image from "@/components/global/Image";
import Link from "next/link";

const FooterPayments = ({ isResponsive = false }) => {
  return (
    <div
      className={`w-11/12 mx-auto ${
        isResponsive ? "block md:hidden" : "hidden md:block"
      }`}
    >
      <div className="flex flex-wrap items-center justify-center gap-4 pt-2 lg:justify-between lg:pt-7">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-3 lg:justify-start">
          <Image
            loading="lazy"
            src="/imgs/payments/mada.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tasaheel"
          />
          <Image
            loading="lazy"
            src="/imgs/payments/tasaheel.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tasaheel"
          />
          <Image
            loading="lazy"
            src="/imgs/payments/tabby_installments.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="tabby_installments"
          />
          <Image
            loading="lazy"
            src="/imgs/payments/new_tamara_pay_by_instalments_4.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="new_tamara_pay_by_instalments_4"
          />
          <Image
            loading="lazy"
            src="/imgs/payments/visa.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="visa"
          />
          <Image
            loading="lazy"
            src="/imgs/payments/installment.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-5 w-16 h-[26px] px-2 rounded-lg bg-white"
            alt="visa"
          />

          <Image
            loading="lazy"
            src="/imgs/payments/cod.png"
            className="object-contain max-[768px]:w-10 max-[768px]:h-8 w-16 h-8"
            alt="cod"
          />
        </div>

        <div className="flex items-center gap-4 mx-auto sm:mx-0">
          <Link href="/pdfs/4030127263-CR.pdf" target="_blank">
          <Image
            loading="lazy"
            src="/imgs/Qr.png"
            className="object-contain max-sm:size-9 size-16"
            alt="Qr"
          />
          </Link>
          <Image
            loading="lazy"
            src="/imgs/Percentage.png"
            className="object-contain max-sm:size-9 size-16"
            alt="Percentage"
          />
          <Link href="/pdfs/VAT.pdf" target="_blank">
          <Image
            loading="lazy"
            src="/imgs/vat.svg"
            className="object-contain max-sm:size-9 size-16"
            alt="Tax"
          />
          </Link>
          <Link href="https://maroof.sa/businesses/details/244240" target="_blank">
          <Image
            loading="lazy"
            src="/imgs/Maarouf.png"
            className="object-contain max-sm:size-9 size-16"
            alt="Maarouf"
          />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterPayments;
